export const enum AddressTypeEnum {
    // 送货地址
    SHIPPING_ADDRESS = "shippingAddress",
    // 账单地址
    BILLING_ADDRESS = "billingAddress",
    // 退货地址
    RETURN_ADDRESS = "returnAddress",
    // 退货地址
    REFUND_ADDRESS = "refundAddress"
}